import {requestWithToken} from "@/utils/functions";
import {SERVICE_API_URL} from "@/utils/constants";
import {useQuery} from "react-query";

interface ApiKey {
    id: string;
    name: string;
    key: string;
    created_at: string;
    issued_at: string;
}

export function resolveApiKeys() {
    return useQuery<ApiKey[]>({
        queryKey: ["customer.api.keys"],
        queryFn: async () => {
            const response = await requestWithToken(`${SERVICE_API_URL}/v2/apikeys`);
            return response?.data?.data?.apikeys || [];
        },
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        retry: false,
        staleTime: 30 * 1000,
        suspense: true
    });
}

export async function mutateResolveApiKey(keyId: string) {
    const response = await requestWithToken(
        `${SERVICE_API_URL}/v2/apikeys/resolve`,
        "POST",
        { id: keyId }
    );
    
    return response?.data;
}

export async function mutateCreateApiKey(name: string) {
    const response = await requestWithToken(
        `${SERVICE_API_URL}/v2/apikeys`,
        "POST",
        { name }
    );
    
    return response?.data;
}

export async function mutateRevokeApiKey(keyId: string) {
    const response = await requestWithToken(
        `${SERVICE_API_URL}/v2/apikeys/${keyId}`,
        "DELETE"
    );
    
    return response?.data;
} 